import { render, staticRenderFns } from "./dsInfo.vue?vue&type=template&id=478a2ac0&"
import script from "./dsInfo.vue?vue&type=script&lang=js&"
export * from "./dsInfo.vue?vue&type=script&lang=js&"
import style0 from "./dsInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports